import React from "react";

import CreateSupplier, { createSupplier } from '../../../../api/suppliers'
import Modal from "../../../../_components/Modal";
import Column from "../../../../_components/Layout/Column"
import Text from "../../../../_components/Text";
import LoadingInput from '../../../../_components/LoadingInput'
import { useState } from "react";
import Button from "../../../../_components/Button";
import Row from "../../../../_components/Layout/Row";
import CheckBox from "../../../../_components/Checkbox";
export default function CreateSupplierModal( props ) {
    const [loading, setLoading] = useState(false)
    const [isPerson, setIsPerson] = useState(false)
    const [supplier, setSupplier] = useState({
        name: "",
        phone_number: "",
        email: "",
        company: {
            cnpj:"",
            fancy_name: "",
        },
        individual: {
            cpf: ""
        }
    })
    function onHide(){
        if(props.onHide){
            props.onHide()
        }
    }

    function onSave(){
        setLoading(true)
        let tempdata = supplier
        tempdata.phone_number = tempdata.phone_number.replace(/[-()\s]/g, '')
        isPerson ? delete tempdata.company : delete tempdata.individual
        createSupplier(supplier).then( () => {
            props.onSave("Fornecedor cadastrado com sucesso!");
            props.onHide();
            setLoading(false)
        }
        ).catch((e) => {
            props.onSave("Erro na criação de fornecedor! Por favor, tente de novo.")
            setLoading(false)
        })
    }

    function onChange(e){
        let { name, value } = e.target;
        let tempdata = supplier
        if(name == "individual"){
            tempdata[name].cpf = value.replace(/[-./]/g, '')
            return
        }
        else if (name == "company"){
            tempdata[name].cnpj = value.replace(/[-./]/g, '')
            return
        }

        else if (name == 'fancy_name'){
            tempdata['company'].fancy_name = value
        }
        tempdata[name] = value
        setSupplier(tempdata)
    }
    return (
        <Modal
            title="Cadastrar fornecedor"
            show={props.show}
            onHide={props.onHide}
            >
            <Row> 
                <Column xs="12" md="4" lg="6">
                <Text>Nome</Text>               
                <LoadingInput name='name' onChange={onChange} disabled={loading}/>
            </Column>
            <Column xs="12" md="4" lg="6">
                <Text>E-mail</Text>   
                <LoadingInput name='email' onChange={onChange} disabled={loading}/>
            </Column>
            <Column xs="12" md="4" lg="6">
                <Text>Telefone</Text>   
                <LoadingInput type='phone_number' name='phone_number' disabled={loading} onChange={onChange}/>
            </Column>
            <Column xs="12" md="4" lg="6" hide={isPerson}>
                <Text>CNPJ</Text>   
                <LoadingInput name='company' type="cnpj" disabled={loading} onChange={onChange}/>
            </Column>
            <Column xs="12" md="4" lg="6" hide={isPerson}>
                <Text>Nome da empresa</Text>   
                <LoadingInput name='fancy_name' disabled={loading} onChange={onChange}/>
            </Column>
            <Column xs="12" md="4" lg="6" hide={!isPerson}>
                <Text>CPF</Text>   
                <LoadingInput name='individual' type='cpf' disabled={loading} onChange={onChange}/>
            </Column>
            <Column xs="12" md="4" lg="6">
                    <CheckBox classname="flex-end" isabled={loading} onClick={value => setIsPerson(!isPerson)} checked={isPerson} label="Fornecedor é pessoa fisica"/>
            </Column>
            </Row>
            
            <Button classname='center' disabled={loading} loading={loading} onClick={() => {onSave()}}>Cadastrar fornecedor</Button>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Purchases/modals/createSupplierModal.jsx